import styles from 'styles/views/widgets/Notifier.css';
import config from 'config/config_server.json';
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import IconButton from './IconButton';

export default class Notifier extends Component {
  static propTypes = {
    success: PropTypes.bool,
    message: PropTypes.string
  }

  constructor (...args) {
    super(...args);
    this.state = {
      visible: true
    };
  };

  render () {
    const { success, message } = this.props;
    let closeUrl = `${config.editorUrl}/close.png`;

    if (!this.state.visible) {
      return null;
    }

    return (
      <div className={classnames({[styles.container]: success, [styles.error_container]: !success})}>
        <div className={classnames({[styles.message]: success, [styles.message_error]: !success})}>
          {message}
        </div>
        <div className={styles.close}>
          <IconButton onClick={this.handleClose}>
            <img src={closeUrl} width='12' height='12'/>
          </IconButton>
        </div>
      </div>
    );
  }

  handleClose = () => {
    this.setState({
      visible: false
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Notifier.js
 **/